import React from 'react'
import styled from 'styled-components'
import TypographyAtom from '../typography/typography.atom'
import item_details_summaryStyles from './item_details_summary.styles'
import utils from '../../../utils'
import {Visit} from '../../../props_reusable/visit'

const apAtomName = {ap_atom_name: 'apItemDetailsSummaryAtom'}

const StyledWrapper = styled(props => <section {...props} />)`
  ${item_details_summaryStyles}
`

const ItemDetailsSummaryAtom: React.FC<
  Pick<Visit, 'visitType' | 'itemDetailsSummary' | 'itemsSummaryLabels'>
> = function ({visitType, itemDetailsSummary, itemsSummaryLabels}) {
  const ids = itemDetailsSummary
  const labels = itemsSummaryLabels
  const {isQtyPlural} = utils

  const deliveryItems = ids.delivery.items
  const deliveryBoxes = ids.delivery.boxes
  const collectionItems = ids.collection.items
  const collectionBoxes = ids.collection.boxes

  const summaryLabelFn = (
    items: number,
    boxes: number,
    labelsObj: {
      [key: string]: string
    },
  ) => {
    if (isQtyPlural(items) && isQtyPlural(boxes)) return labelsObj.plural
    if (!isQtyPlural(items) && isQtyPlural(boxes)) return labelsObj.boxPlural
    if (isQtyPlural(items) && !isQtyPlural(boxes)) return labelsObj.itemPlural
    return labelsObj.singular
  }

  return (
    <StyledWrapper {...apAtomName}>
      {visitType === 'Delivery' && (
        <TypographyAtom ahd_type="sData">
          {`${summaryLabelFn(deliveryItems, deliveryBoxes, labels.delivery)}`
            .replace('{x}', `${deliveryItems}`)
            .replace('{y}', `${deliveryBoxes}`)}
        </TypographyAtom>
      )}
      {visitType === 'Collection' && (
        <TypographyAtom ahd_type="sData">
          {`${summaryLabelFn(
            collectionItems,
            collectionBoxes,
            labels.collection,
          )}`
            .replace('{x}', `${collectionItems}`)
            .replace('{y}', `${collectionBoxes}`)}
        </TypographyAtom>
      )}
      {visitType === 'Exchange' && (
        <TypographyAtom ahd_type="sData">
          {`${summaryLabelFn(deliveryItems, deliveryBoxes, labels.delivery)}`
            .replace('{x}', `${deliveryItems}`)
            .replace('{y}', `${deliveryBoxes}`)}
          <br />
          {`${summaryLabelFn(
            collectionItems,
            collectionBoxes,
            labels.collection,
          )}`
            .replace('{x}', `${collectionItems}`)
            .replace('{y}', `${collectionBoxes}`)}
        </TypographyAtom>
      )}
    </StyledWrapper>
  )
}

export default ItemDetailsSummaryAtom
